import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { AutoTextarea } from "@/components/AutoTextarea";

const RESERVED = new Set(["summary", "content", "aliases", "images", "name"]);

const applyDiff = (ytext, prev, next) => {
  let a = 0;
  while (a < prev.length && a < next.length && prev[a] === next[a]) a++;
  let b = 0;
  while (b < prev.length - a && b < next.length - a && prev[prev.length - 1 - b] === next[next.length - 1 - b]) b++;
  ytext.doc.transact(() => {
    if (prev.length - a - b > 0) ytext.delete(a, prev.length - a - b);
    if (next.length - a - b > 0) ytext.insert(a, next.slice(a, next.length - b));
  });
};

export const LiveSummary = ({ live, editable }) => {
  const ytext = live.sock.doc.getText("summary");
  const [val, setVal] = useState(ytext.toString());
  useEffect(() => {
    const upd = () => setVal(ytext.toString());
    upd();
    ytext.observe(upd);
    return () => ytext.unobserve(upd);
  }, [ytext]);
  return (
    <AutoTextarea value={val} disabled={!editable} maxVh={40} data-testid="live-summary-input" placeholder="One or two lines that sum this entry up…"
      onChange={(e) => { applyDiff(ytext, val, e.target.value); setVal(e.target.value); }}
      className="w-full resize-none border-0 border-b border-dashed border-transparent bg-transparent p-0 font-display text-xl italic leading-snug text-[#E8DFD1] shadow-none hover:border-[#2D3442] focus:border-[#D97706]/60 focus-visible:ring-0" />
  );
};

export const LiveFields = ({ live, editable, ent }) => {
  const ymap = live.sock.doc.getMap("attributes");
  const [vals, setVals] = useState(ymap.toJSON());
  useEffect(() => {
    const upd = () => setVals(ymap.toJSON());
    upd();
    ymap.observe(upd);
    return () => ymap.unobserve(upd);
  }, [ymap]);
  const missing = (ent.completeness?.missing || []).filter((f) => !RESERVED.has(f.key));
  const labels = Object.fromEntries(missing.map((f) => [f.key, f.label]));
  const keys = [...new Set([...Object.keys(vals), ...missing.map((f) => f.key)])];
  if (!keys.length) return null;
  return (
    <dl className="grid grid-cols-[auto_1fr] items-center gap-x-6 gap-y-1.5 border-l-2 border-[#D97706]/40 pl-4 text-sm" data-testid="live-fields">
      {keys.map((k) => (
        <div key={k} className="contents">
          <dt className="capitalize text-[#A8A090]">{labels[k] || k.replace(/_/g, " ")}</dt>
          <dd>
            <Input value={vals[k] ?? ""} disabled={!editable} placeholder={editable ? "—" : ""} data-testid={`live-field-${k}`}
              onChange={(e) => ymap.set(k, e.target.value)}
              className="h-8 border-transparent bg-transparent px-1.5 text-[#F3EBDD] shadow-none hover:border-[#2D3442] focus-visible:border-[#D97706]/60 focus-visible:ring-0 disabled:cursor-default disabled:opacity-100" />
          </dd>
        </div>
      ))}
    </dl>
  );
};
